'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var ServerStatus = function ServerStatus(_ref) {
  var children = _ref.children;
  return _react2['default'].Children.only(children);
};
ServerStatus.displayName = 'ServerStatus';

exports['default'] = ServerStatus;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-server-status/lib/browser.js
 ** module id = 1296
 ** module chunks = 1
 **/